export default {
  items: [
    {
      name: 'Menu Principal',
      icon: 'icon-speedometer',
      children: [
        {
          name: 'Avaliar Voluntária',
          url: '/avaliar-voluntarias',
          icon: 'fa fa-star'
        },
        {
          name: 'Realizar um Feedback',
          url: '/feedbacks/novo',
          icon: 'fa fa-comments-o'
        },
        {
          name: 'Depoimentos',
          url: '/depoimentos/list',
          icon: 'fa fa-commenting-o'
        },
        {
          name: 'Perguntas e Respostas',
          url: '/faqs/list',
          icon: 'fa fa-question-circle'
        },
        {
          name: 'Informações e Notícias',
          url: '/informacoes-noticias',
          icon: 'fa fa-info'
        },
        {
          name: 'Cursos',
          url: '/cursos-listar',
          icon: 'fa fa-youtube-play'
        },
        {
          name: 'Programas de Governo',
          url: '/programas-listar',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Programas do Município',
          url: 'programas-municipios-listar',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Regulamento do Projeto',
          url: '/arquivos-regulamento',
          icon: 'fa fa-files-o'
        },
        {
          name: 'Ebook Mães Unidas',
          url: '/arquivos-ebook',
          icon: 'fa fa-files-o'
        },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_navBeneficiario.js